export default __webpack_public_path__ + "static/heroSectionImg2-d410f7b55427db4ac4ee66556bcbea23.webp";